import React, { useEffect, useState, MouseEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import posthog from 'posthog-js';

import '../scss/vip-meal.scss';
import Color from '@/tool/color';
import moUser from '@store/user';
import { toggleLogin } from '@store/index';
import { changeApply, changeText } from '../store/index';
import Bg01 from '@image/bg03.png';
import Bg02 from '@image/bg01.png';
import Bg03 from '@image/bg02.png';
import Bg04 from '@image/bg-vip.png';
import moSkin from '@/store/skin';

interface IProps { }
interface IState { }

const VButton = styled(Button)(() => ({
  width: '100%',
  height: '50px',
  borderRadius: '25px',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: 1,
  color: '#010101',
}));

const VipMeal = (props: IProps, state: IState) => {
  const location = useLocation();
  const navi = useNavigate();
  const { isLogin } = moUser;
  const { pricePage, partner } = moSkin;

  useEffect(() => {
    return () => { };
  }, []);

  // 申请开通
  const toApply = (value: string) => {
    if (value === '注册会员') {
      return;
    }
    posthog.capture('点击申请开通的人数', {});
    // 悦享服务
    changeText(
      `${value}套餐申请`,
      `点击“提交”即可将您的企业套餐需求申请发送至${partner === 'smartsalary' ? '薪智' : ''}顾问。`,
      `${partner === 'smartsalary' ? '薪智' : ''}顾问会在第一时间联系您。`,
    );
    if (!isLogin) toggleLogin(true);
    else changeApply(true);
  };

  return (
    <section className="meal-service">
      {
        pricePage?.map((res: any, i: any) => {
          return (<section className="meal-card" key={`${i}s`}>
            <p className="p-50 p-51">
              <img src={res.bg_url} alt="bg" />
              <span>{res.name.slice(0, 4)}</span>
              <span className="span-50">{res.name.slice(4)}</span>
            </p>
            <section className="card-60">
              <p className="price-100">
                <b>¥</b>
                <strong>{res.price.toLocaleString()}</strong>
                <span>{res.name === '定制服务' ? '/份起' : '/年起'}</span>
              </p>
              <br/><br/>
              {res.tags.length > 0 && <p className="lit-10">
                <span />
                <i>推荐使用场景</i>
                <span />
              </p>}
              {res.tags.length > 0 &&
                <p className={`tag-10 ${res.tags.length === 1 ? 'tag-11' : ''}`}>
                  {
                    res.tags.map((item: any, i: any) => {
                      return <span key={`${i}p`}>{item}</span>;
                    })
                  }
                </p>}
              <p className="apply-10">
                <VButton variant="contained" color="secondary"
                  onClick={() => toApply(res.name)}>{res.name === '注册会员' ? '免费使用' : '咨询开通'}
                </VButton>
              </p>
              <p className="lit-10">
                <span />
                <i>套餐权益对比</i>
                <span />
              </p>
              <section className="list-11">
                {
                  res.content.map((ele: any, e: any) => {
                    return (
                      <p className={ele.active ? 'light-11' : ''} key={`${e}l`}>
                        <span>{ele.module}</span>
                        <i className="iconfont icon-copy-s" />
                      </p>);
                  })
                }
              </section>
            </section>
          </section>);
        })
      }
    </section>
  );
};

export default observer(VipMeal);
